// Game Configuration and Constants
export const GAME_CONFIG = {
  title: 'Anunnaki vs Humans: The Ten Parts of Truth',
  version: '0.1.0',
  width: 1280,
  height: 720,
  tileSize: 32,
  scale: 2
};

// Epochs/Eras
export const EPOCHS = {
  GOLDEN_AGE: {
    id: 0,
    name: 'The Golden Age',
    levelRange: [1, 100],
    description: 'Pre-Reset Earth - Advanced light-based civilization',
    timePeriod: '50,000+ years ago'
  },
  FIRE_RESET: {
    id: 1,
    name: 'The Fire Reset',
    levelRange: [101, 300],
    description: 'World destruction by fire/plasma weapons',
    timePeriod: '~12,000 years ago'
  },
  FLOOD_RESET: {
    id: 2,
    name: 'The Flood Reset',
    levelRange: [301, 500],
    description: 'Global deluge, survival at sea',
    timePeriod: '~10,000 years ago'
  },
  CLAY_AGE: {
    id: 3,
    name: 'The Clay Age',
    levelRange: [501, 999],
    description: 'Bronze to Modern era, final battle',
    timePeriod: '4,000 BCE - Present'
  }
};

// Factions
export const FACTIONS = {
  HUMAN: {
    id: 'human',
    name: 'Human',
    description: 'Fight for freedom. Destroy mines. Kick Anunnaki off Earth.',
    color: '#4CAF50',
    weakness: 'Outnumbered',
    victoryCondition: 'Complete the Global Stone Initiative before level 999'
  },
  HYBRID: {
    id: 'hybrid',
    name: 'Hybrid (Nephilim)',
    description: 'Powerful but outnumbered. Ally with humans for strength!',
    color: '#9C27B0',
    weakness: 'Identity Crisis',
    victoryCondition: 'Unite both sides'
  },
  ANUNNAKI: {
    id: 'anunnaki',
    name: 'Anunnaki',
    description: 'Mine gold to save Nibiru. Don\'t wipe out humans.',
    color: '#2196F3',
    weakness: 'Starvation without gold',
    victoryCondition: 'Mine enough gold to infuse Nibiru\'s atmosphere by level 999'
  },
  GIANT: {
    id: 'giant',
    name: 'Giant',
    description: 'DUMB STRONG but need MASSIVE food. Risk of STARVATION!',
    color: '#795548',
    weakness: 'Starvation',
    victoryCondition: 'Survive to the end'
  },
  IGIGI: {
    id: 'igigi',
    name: 'Igigi',
    description: 'HIVE MIND. Powerful but vulnerable leadership!',
    color: '#FFD700',
    weakness: 'Hive Vulnerable',
    victoryCondition: 'Protect the Queen'
  }
};

// The 13 Fallen Characters
export const THE_13_FALLEN = {
  // Corrupted Scepter Bearers (Antagonists)
  ENLIL: {
    id: 'enlil',
    name: 'Enlil (Anu)',
    origin: 'Sumerian',
    role: 'Command Over Consent',
    type: 'boss',
    faction: 'corrupted',
    epoch: 1,
    stats: { hp: 5000, attack: 150, defense: 100, speed: 80 },
    abilities: ['Storm Strike', 'Lightning Mace', 'Divine Command']
  },
  SET: {
    id: 'set',
    name: 'Set',
    origin: 'Egyptian',
    role: 'Weaponized Domination',
    type: 'boss',
    faction: 'corrupted',
    epoch: 1,
    stats: { hp: 4500, attack: 180, defense: 80, speed: 100 },
    abilities: ['Chaos Storm', 'Red Fury', 'Desert Wrath']
  },
  LUGALBANDA: {
    id: 'lugalbanda',
    name: 'Lugalbanda',
    origin: 'Sumerian',
    role: 'Badge of Supremacy',
    type: 'boss',
    faction: 'corrupted',
    epoch: 2,
    stats: { hp: 4000, attack: 120, defense: 120, speed: 70 },
    abilities: ['False Judgment', 'Royal Decree', 'Crown\'s Weight']
  },
  ATLAS: {
    id: 'atlas',
    name: 'Atlas',
    origin: 'Greek',
    role: 'Burden-Bearing Power',
    type: 'boss',
    faction: 'corrupted',
    epoch: 1,
    stats: { hp: 8000, attack: 200, defense: 150, speed: 40 },
    abilities: ['World Crush', 'Titan Strength', 'Earth Shatter']
  },
  HYKSOS_KING: {
    id: 'hyksos_king',
    name: 'Hyksos Priest-King',
    origin: 'Egyptian/Foreign',
    role: 'Symbol of Conquest',
    type: 'boss',
    faction: 'corrupted',
    epoch: 3,
    stats: { hp: 3500, attack: 130, defense: 90, speed: 90 },
    abilities: ['Mind Control', 'Conquest March', 'False Balance']
  },
  MARDUK: {
    id: 'marduk',
    name: 'Marduk',
    origin: 'Babylonian',
    role: 'The Usurper - Killed the Truth',
    type: 'final_boss',
    faction: 'corrupted',
    epoch: 4,
    stats: { hp: 15000, attack: 250, defense: 200, speed: 100 },
    abilities: ['Truth Division', 'Reset Trigger', 'God-Killer', 'Tablet Strike']
  },

  // Righteous Scepter Bearers (Allies)
  SOLOMON: {
    id: 'solomon',
    name: 'Solomon',
    origin: 'Hebrew',
    role: 'Covenant-Calibrator',
    type: 'companion',
    faction: 'righteous',
    epoch: 3,
    stats: { hp: 2000, attack: 80, defense: 100, speed: 70 },
    abilities: ['Divine Wisdom', 'Covenant Shield', 'Truth Binding']
  },
  THOTH: {
    id: 'thoth',
    name: 'Thoth',
    origin: 'Egyptian',
    role: 'Knowledge Keeper',
    type: 'companion',
    faction: 'righteous',
    epoch: 0,
    stats: { hp: 1800, attack: 100, defense: 80, speed: 90 },
    abilities: ['Record Truth', 'Magic Script', 'Memory Recall']
  },
  NINHURSAG: {
    id: 'ninhursag',
    name: 'Ninhursag',
    origin: 'Sumerian',
    role: 'Life-Granter',
    type: 'companion',
    faction: 'righteous',
    epoch: 1,
    stats: { hp: 2200, attack: 60, defense: 90, speed: 60 },
    abilities: ['Heal', 'Life Bloom', 'Nature\'s Shield']
  },
  MAAT: {
    id: 'maat',
    name: 'Ma\'at',
    origin: 'Egyptian',
    role: 'Truth Weigher',
    type: 'companion',
    faction: 'righteous',
    epoch: 3,
    stats: { hp: 1900, attack: 90, defense: 110, speed: 80 },
    abilities: ['Weigh Heart', 'Balance Strike', 'Truth Reveal']
  },
  OANNES: {
    id: 'oannes',
    name: 'Oannes/Uanna',
    origin: 'Mesopotamian',
    role: 'Teacher',
    type: 'companion',
    faction: 'righteous',
    epoch: 2,
    stats: { hp: 2100, attack: 70, defense: 85, speed: 100 },
    abilities: ['Water Walk', 'Knowledge Wave', 'Tidal Shield']
  },

  // Serpent Staff Bearers (Neutral)
  NINGISHZIDA: {
    id: 'ningishzida',
    name: 'Ningishzida',
    origin: 'Sumerian',
    role: 'Underworld Lord',
    type: 'boss',
    faction: 'neutral',
    epoch: 3,
    stats: { hp: 4200, attack: 140, defense: 95, speed: 85 },
    abilities: ['Serpent Strike', 'Underworld Gate', 'Vegetation Bind']
  },
  HERMES: {
    id: 'hermes',
    name: 'Hermes',
    origin: 'Greek',
    role: 'Messenger',
    type: 'companion',
    faction: 'neutral',
    epoch: 3,
    stats: { hp: 1600, attack: 110, defense: 70, speed: 150 },
    abilities: ['Swift Strike', 'Boundary Cross', 'Caduceus Wave']
  }
};

// The 10 Truth Fragments
export const TRUTH_FRAGMENTS = {
  ORIGIN: {
    id: 'origin',
    name: 'Origin (Bereshit)',
    hebrew: 'בְּרֵאשִׁית',
    meaning: 'In the beginning',
    epoch: 0,
    level: 25,
    effect: '+20% Max HP',
    description: 'The problem of beginning. The singularity from which all differentiation proceeds.'
  },
  SEPARATION: {
    id: 'separation',
    name: 'Separation (Havdalah)',
    hebrew: 'הַבְדָּלָה',
    meaning: 'Division',
    epoch: 0,
    level: 50,
    effect: 'Unlock Dual-Wield',
    description: 'The universe creates complexity by breaking its own symmetry.'
  },
  NAME: {
    id: 'name',
    name: 'Name (Shem)',
    hebrew: 'שֵׁם',
    meaning: 'Name/Identity',
    epoch: 0,
    level: 100,
    effect: 'Reveal Enemy Stats',
    description: 'To observe is to name. The particle does not exist until named.'
  },
  PATTERN: {
    id: 'pattern',
    name: 'Pattern (Tavnit)',
    hebrew: 'תַּבְנִית',
    meaning: 'Blueprint',
    epoch: 1,
    level: 200,
    effect: 'Predict Enemy Attacks',
    description: 'The architecture that repeats across all creation.'
  },
  COVENANT: {
    id: 'covenant',
    name: 'Covenant (Brit)',
    hebrew: 'בְּרִית',
    meaning: 'Agreement',
    epoch: 1,
    level: 300,
    effect: '+50% Alliance Bonuses',
    description: 'The binding force between particles, peoples, and powers.'
  },
  SACRIFICE: {
    id: 'sacrifice',
    name: 'Sacrifice (Korban)',
    hebrew: 'קָרְבָּן',
    meaning: 'Offering',
    epoch: 2,
    level: 400,
    effect: 'Sacrifice HP for Power',
    description: 'Nothing is created without something being given up.'
  },
  MEMORY: {
    id: 'memory',
    name: 'Memory (Zikaron)',
    hebrew: 'זִכָּרוֹן',
    meaning: 'Remembrance',
    epoch: 2,
    level: 500,
    effect: 'Recall Defeated Enemies as Allies',
    description: 'DNA is molecular memory. The ancestors live within the living.'
  },
  JUDGMENT: {
    id: 'judgment',
    name: 'Judgment (Mishpat)',
    hebrew: 'מִשְׁפָּט',
    meaning: 'Justice',
    epoch: 3,
    level: 650,
    effect: '+30% Critical Hit Chance',
    description: 'The weighing of truth against intention.'
  },
  RETURN: {
    id: 'return',
    name: 'Return (Teshuvah)',
    hebrew: 'תְּשׁוּבָה',
    meaning: 'Repentance/Return',
    epoch: 3,
    level: 800,
    effect: 'Resurrection (once per battle)',
    description: 'The cycle that brings all things back to origin.'
  },
  UNITY: {
    id: 'unity',
    name: 'Unity (Echad)',
    hebrew: 'אֶחָד',
    meaning: 'One',
    epoch: 4,
    level: 999,
    effect: 'Unite All Powers',
    description: 'The organism of truth viewed from all angles at once.'
  }
};

// Player Classes
export const PLAYER_CLASSES = {
  WARRIOR: {
    id: 'warrior',
    name: 'Warrior',
    description: 'Melee combat specialist',
    baseStats: { hp: 120, attack: 15, defense: 12, speed: 8, mana: 30 },
    growthRates: { hp: 12, attack: 2, defense: 1.5, speed: 0.8, mana: 2 }
  },
  MAGE: {
    id: 'mage',
    name: 'Mage',
    description: 'Truth-powered magic user',
    baseStats: { hp: 80, attack: 8, defense: 6, speed: 10, mana: 100 },
    growthRates: { hp: 6, attack: 0.8, defense: 0.5, speed: 1, mana: 10 }
  },
  SCOUT: {
    id: 'scout',
    name: 'Scout',
    description: 'Fast and agile',
    baseStats: { hp: 90, attack: 12, defense: 8, speed: 15, mana: 50 },
    growthRates: { hp: 8, attack: 1.5, defense: 0.8, speed: 2, mana: 4 }
  },
  HEALER: {
    id: 'healer',
    name: 'Healer',
    description: 'Support and restoration',
    baseStats: { hp: 100, attack: 6, defense: 10, speed: 9, mana: 80 },
    growthRates: { hp: 10, attack: 0.5, defense: 1, speed: 0.9, mana: 8 }
  }
};

// Color Palettes
export const COLORS = {
  factions: {
    human: { primary: '#4CAF50', secondary: '#81C784', accent: '#FFD700' },
    hybrid: { primary: '#9C27B0', secondary: '#BA68C8', accent: '#E1BEE7' },
    anunnaki: { primary: '#2196F3', secondary: '#64B5F6', accent: '#FFD700' },
    giant: { primary: '#795548', secondary: '#A1887F', accent: '#D7CCC8' },
    igigi: { primary: '#FFD700', secondary: '#FFF176', accent: '#7B68EE' }
  },
  epochs: {
    goldenAge: { primary: '#FFFDE7', secondary: '#FFF59D', accent: '#FFD700' },
    fireReset: { primary: '#FF5722', secondary: '#FF8A65', accent: '#FFCCBC' },
    floodReset: { primary: '#0288D1', secondary: '#4FC3F7', accent: '#B3E5FC' },
    clayAge: { primary: '#8D6E63', secondary: '#A1887F', accent: '#D7CCC8' }
  },
  ui: {
    health: '#4CAF50',
    mana: '#2196F3',
    experience: '#FFD700',
    danger: '#F44336',
    success: '#4CAF50'
  }
};

export default {
  GAME_CONFIG,
  EPOCHS,
  FACTIONS,
  THE_13_FALLEN,
  TRUTH_FRAGMENTS,
  PLAYER_CLASSES,
  COLORS
};
